var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-list',{attrs:{"finished-text":"没有更多了","finished":_vm.finished,"immediate-check":true},on:{"load":_vm.onLoad},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},_vm._l((_vm.list),function(item,index){return _c('clazz-panel',{key:index,attrs:{"clazz":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }